const innovative = [
  {
    path: '/innovative',
    name: 'innovative',
    meta: { title: '四川省创新型中小企业评估测试', node: 'innovative', reviewType: 5 },
    component: () => import('../views/innovative/index.vue')
  },
  {
    path: '/innovative_evaluation',
    name: 'innovative_evaluation',
    meta: { title: '四川省创新型中小企业评估测试', node: 'innovative', reviewType: 5, childNode: true },
    component: () => import('../views/innovative/evaluation.vue')
  },
  {
    path: '/innovative_result',
    name: 'innovative_result',
    meta: { title: '四川省创新型中小企业评估测试', node: 'innovative', reviewType: 5 },
    component: () => import('../views/innovative/result.vue')
  }
]

export default innovative;